import React, { useState } from "react";
import { CheckCircle2, Circle, Loader2, ShieldCheck, ScanSearch } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton } from "./shared";

const CHECKS = [
  ["Identity verification", "Owner ID matched · liveness passed"],
  ["TIN match", "IRS TIN/name match confirmed"],
  ["OFAC sanctions", "No matches on SDN list"],
  ["Secretary of State", "Active · good standing"],
  ["Background check", "No adverse records"],
];

export default function KycCard({ merchant }) {
  const [status, setStatus] = useState({}); // i -> "run" | "pass"
  const [running, setRunning] = useState(false);
  const verified = Object.values(status).filter((s) => s === "pass").length === CHECKS.length;

  const run = async () => {
    setRunning(true);
    setStatus({});
    for (let i = 0; i < CHECKS.length; i += 1) {
      setStatus((s) => ({ ...s, [i]: "run" }));
      await sleep(650);
      setStatus((s) => ({ ...s, [i]: "pass" }));
    }
    setRunning(false);
  };

  return (
    <ActiveCardShell id="T2300cr" kicker="VERIFICATION" title="Automated KYB / KYC Verification" Icon={ShieldCheck}
      actions={<RunButton tid="veroogle-t2300-run" running={running} onClick={run} Icon={running ? Loader2 : ScanSearch} label="Run verification" />}>
      <div className="relative">
        <ul className="space-y-2">
          {CHECKS.map(([label, detail], i) => {
            const st = status[i];
            const Icon = st === "pass" ? CheckCircle2 : st === "run" ? Loader2 : Circle;
            return (
              <li key={label} data-testid={`veroogle-t2300-check-${i}`} className="flex items-center gap-3 rounded-lg border border-white/10 bg-navy-950/40 px-3 py-2.5">
                <Icon className={`w-4 h-4 shrink-0 ${st === "pass" ? "text-emerald-400" : st === "run" ? "text-brand-cyan animate-spin" : "text-slate-600"}`} />
                <span className="text-sm text-white flex-1">{label}</span>
                <span className="text-xs text-slate-400 hidden sm:inline">{st === "pass" ? detail : st === "run" ? "Checking…" : "Pending"}</span>
              </li>
            );
          })}
        </ul>
        {verified && (
          <div data-testid="veroogle-t2300-verified"
            className="absolute right-4 -top-2 rotate-[-8deg] px-4 py-1.5 rounded-lg border-2 border-emerald-400 text-emerald-300 font-mono text-sm font-bold tracking-[0.2em] uppercase bg-navy-950/80 shadow-[0_0_24px_rgba(16,185,129,0.35)] animate-in zoom-in-50 fade-in duration-300">
            Verified · {merchant.name.split(" ")[0]}
          </div>
        )}
      </div>
    </ActiveCardShell>
  );
}
